import { Component, Input } from '@angular/core'
// import { ToggleSwitchChangeEvent } from 'primeng/toggleswitch'
// import { UserStateService } from '../../../store/state/user/user.state.service'

@Component({
    selector: 'app-unauthorized-layout',
    templateUrl: './unauthorized-layout.component.html',
    styleUrl: './unauthorized-layout.component.scss',
    standalone: false
})
export class UnauthorizedLayoutComponent {

  src_url = '../../../../assets/terms-privacy.pdf'

  privacyTerms = false

  //  userStateService: UserStateService = inject(UserStateService)

  // onUserSwitch(event: ToggleSwitchChangeEvent) {
  //   this.userStateService.setUserAuthorized(event.checked)
  // }

  showPivacyTerms() {
    this.privacyTerms = true
  }
}


@Component({
    selector: 'app-unauthorized-header-layout',
    styleUrl: './unauthorized-layout.component.scss',
    template: `<div class="flex justify-content-center">
    <div class="w-full text-center">
      <h1 [class]="headerCustomClass" [innerHTML]="header"></h1>
      @if (subHeader && subHeader.length > 0) {
        <h2 [ngClass]="subHeaderCustomClass"><span [innerHTML]="subHeader"></span></h2>
      }
      @if (subHeader2 && subHeader2.length > 0) {
        <h4 class="mb-0 text-lg font-light" [innerHTML]="subHeader2"></h4>
      }
    </div>
  </div>`,
    standalone: false
})
export class UnauthorizedHeaderComponent {
  @Input() headerCustomClass: string = '';
  @Input() subHeaderCustomClass: string = 'semi-bold';
  @Input() header: string = '';
  @Input() subHeader: string = ''
  @Input() subHeader2: string = ''

}
